export default __webpack_public_path__ + "static/media/scratch12.3eb8b64a.mp3";